<script>
import { BButton, BCard, BCol, BCollapse, BModal, BRow } from "bootstrap-vue"

export default {
  name: "ErrorMessage",
  components: { BModal, BRow, BCol, BCollapse, BCard, BButton },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  emits: ["update:visible"],
  data() {
    return {
      collapse: false,
    }
  },
  created() {},
  methods: {
    Copy() {
      navigator.clipboard.writeText(this.data.detail)
      this.$notification(this.$t("SuccessCopy"), "success")
    },
  },
}
</script>

<template>
  <div>
    <BModal
      :model-value="visible"
      size="xl"
      hide-footer
      header-bg-variant="danger"
      @update:model-value="$emit('update:visible', $event)"
    >
      <template #modal-title>
        <b class="text-white">error</b>
      </template>
      <BRow>
        <BCol>
          <b> title : </b> <span> {{ data.title }} </span>
        </BCol>
      </BRow>
      <BRow class="mt-1">
        <BCol>
          <BButton
            variant="outline-primary"
            size="sm"
            @click="collapse = !collapse"
          >
            detail <feather-icon icon="ChevronsRightIcon" />
          </BButton>
        </BCol>
        <BCol class="text-end">
          <BButton
            variant="success"
            size="sm"
            @click="Copy"
          >
            <feather-icon icon="CopyIcon" /> Copy
          </BButton>
        </BCol>
      </BRow>
      <BRow class="mt-2">
        <BCol>
          <BCollapse v-model="collapse">
            <BCard style="overflow-y: scroll; height: calc(100vh - 230px)">
              <span ref="text">
                <pre>  {{ data.detail }} </pre>
              </span>
            </BCard>
          </BCollapse>
        </BCol>
      </BRow>
    </BModal>
  </div>
</template>

<style></style>
